module.exports = __webpack_public_path__ + "static/media/DefaultProfile.d069fa33.svg";